/**
 * Blue Zone Pre-order Modal - Bootstrap Script
 * Global trigger listener and modal loader
 * Based on Introbox bootstrap patterns for consistency
 */

(function() {
  'use strict';
  
  let modalLoaded = false;
  let modalScriptsLoaded = false;
  
  /**
   * Check if current page should show pre-order modal
   * @returns {boolean} True if page contains /pre-order in path
   */
  function shouldShowPreorderModal() {
    return window.location.pathname.includes('/pre-order');
  }
  
  /**
   * Load the main modal bundle and dependencies
   */
  function loadPreorderModal() {
    if (modalLoaded) {
      window.PreorderModal.open().catch(error => {
        console.warn('Failed to open Pre-order modal:', error);
      });
      return;
    }
    
    if (modalScriptsLoaded) return;
    modalScriptsLoaded = true;
    
    // Load CSS first
    const cssUrl = '/assets/preorder-modal.css';
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = cssUrl;
    document.head.appendChild(link);
    
    // Load scripts sequentially to ensure proper dependency order
    const scriptsToLoad = [
      '/assets/preorder-cart-handler.js',
      '/assets/preorder-modal.js'
    ];
    
    let currentScriptIndex = 0;
    
    function loadNextScript() {
      if (currentScriptIndex >= scriptsToLoad.length) {
        // All scripts loaded, initialize modal
        modalLoaded = true;
        window.PreorderModal.init();
        // Ensure modal becomes visible when JS is ready
        const root = document.getElementById('preorder-modal');
        if (root) root.style.display = '';
        window.PreorderModal.open().catch(error => {
          console.warn('Failed to open Pre-order modal:', error);
        });
        return;
      }
      
      const script = document.createElement('script');
      script.src = scriptsToLoad[currentScriptIndex];
      script.onload = () => {
        currentScriptIndex++;
        loadNextScript();
      };
      script.onerror = () => {
        // Failed to load Pre-order script - silent fail for production
        currentScriptIndex++;
        loadNextScript();
      };
      document.head.appendChild(script);
    }
    
    loadNextScript();
  }
  
  /**
   * Handle trigger clicks
   */
  function handleTriggerClick(e) {
    const target = e.target.closest('a[href="#pre-order"]');
    if (!target) return;
    
    e.preventDefault();
    
    // Check if page should show pre-order modal
    if (!shouldShowPreorderModal()) {
      console.warn('Pre-order modal not available on this page');
      return;
    }
    
    // Track analytics for trigger source
    const source = target.textContent.trim() || target.getAttribute('aria-label') || 'unknown_trigger';
    
    // Apply discount code to URL if not already present
    if (!window.location.search.includes('discount=')) {
      const newUrl = window.location.pathname + '?discount=PRE-ORDER25' + window.location.hash;
      window.history.replaceState({}, '', newUrl);
    }
    
    // Load and open modal
    loadPreorderModal();
    
    // Track analytics after modal opens
    setTimeout(() => {
      if (window.gtag) {
        window.gtag('event', 'pre-order_modal_opened', {
          source: source,
          page: window.location.href
        });
      }
    }, 100);
  }
  
  /**
   * Setup global event listeners
   */
  function setupEventListeners() {
    // Listen for trigger clicks
    document.addEventListener('click', handleTriggerClick, true);
    
    // Listen for hash changes (in case someone navigates to #pre-order)
    window.addEventListener('hashchange', () => {
      if (window.location.hash === '#pre-order' && shouldShowPreorderModal()) {
        loadPreorderModal();
      }
    });
    
    // Check if page was loaded with hash
    if (window.location.hash === '#pre-order' && shouldShowPreorderModal()) {
      loadPreorderModal();
    }
  }
  
  /**
   * Initialize bootstrap when DOM is ready
   */
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setupEventListeners);
    } else {
      setupEventListeners();
    }
  }
  
  // Initialize
  init();
  
})();